import { WifiOff } from '@untitledui/icons';
import { Icon } from './Icon';
import { useGcsStore } from '../../store/useGcsStore';
import { selectIsVehicleConnected } from '../../store/selectors/selectIsVehicleConnected';
import type { VehicleId } from '../../types/gcs/vehicle';
import { en } from '../../locales/en';

interface VehicleConnectionIndicatorProps {
  gcsId: string;
  vehicleId: VehicleId;
}

export const VehicleConnectionIndicator = ({ gcsId, vehicleId }: VehicleConnectionIndicatorProps) => {
  const isVehicleConnected = useGcsStore((state) => selectIsVehicleConnected(state.data, gcsId, vehicleId));

  if (isVehicleConnected) {
    return null;
  }

  return <Icon icon={WifiOff} size={20} color='var(--color-error)' title={en.connectionStatusTitles.disconnected} />;
};
